















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import OkNgModal from "@/components/OkNgModal.vue";
import { Ticket } from "@/models/ticket";
import { Salon } from "@/models/salon";
import TicketSalonTipComponent from "@/components/TicketSalonTipComponent.vue";
import SalonComponent from "@/components/SalonComponent.vue";
import SystemConst from "@/config/const";
import firebase from "firebase/app";
import "firebase/firestore";
const db = firebase.firestore();
import SalonService from "@/services/SalonService";
import SalonFavoriteService from "@/services/SalonFavoriteService";

@Component({
  name: "SalonTicketApp",
  components: {
    TicketSalonTipComponent,
    SalonComponent,
    OkNgModal,
  },
})
export default class SalonTicketApp extends Vue {
  salon_id = "";
  salonIdSystem = "";
  salon: Salon = new Salon();
  tickets: Ticket[] = [];
  viewTickets: Ticket[] = [];
  selectedTicketType = SystemConst.TICKET_TYPE_ALL;
  ticketType = SystemConst.TICKET_TYPE;
  faved = false;
  maxIndex = 10;
  title = "";
  salonExists = false;
  ticketExists = false;
  page = 1;
  total_objects = 0;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  async selectTickets() {
    this.page = 1;
    const params = {
      ticket_type: this.selectedTicketType,
      page: this.page,
      per_page: this.maxIndex,
    };
    const responseTickets = await SalonService.getTickets(
      this.salon_id,
      params
    );
    if (responseTickets.data.tickets) {
      this.tickets = responseTickets.data.tickets;
    }
    this.total_objects = responseTickets.data.total_objects;
    if (this.tickets.length > 0) {
      this.ticketExists = true;
    }
    this.viewTickets = this.tickets;
  }

  async readMore() {
    this.page += 1;
    const params = {
      ticket_type: this.selectedTicketType,
      page: this.page,
      per_page: this.maxIndex,
    };
    const responseTickets = await SalonService.getTickets(
      this.salon_id,
      params
    );
    if (responseTickets.data.tickets) {
      this.tickets = responseTickets.data.tickets;
    }
    this.total_objects = responseTickets.data.total_objects;
    if (this.tickets.length > 0) {
      this.ticketExists = true;
    }
    this.viewTickets = this.viewTickets.concat(this.tickets);
  }

  googleMapUrl(address: string): string {
    const query = encodeURI(address);
    const google = "https://maps.google.co.jp/maps?q=";
    const url = google + query;
    return url;
  }

  async fav() {
    if (localStorage.uid) {
      this.faved = true;
      await SalonFavoriteService.createSalon({ salon_id: this.salon_id });
    } else {
      this.refs.toLoginModal.open();
    }
  }

  async unFav() {
    if (localStorage.uid) {
      this.faved = false;
      await SalonFavoriteService.deleteSalon(this.salon_id);
    } else {
      this.refs.toLoginModal.open();
    }
  }

  openUrl(url: string) {
    if (url) {
      window.open(url, "_blank");
    }
  }

  gotoSignup() {
    const route = this.$router.resolve({ name: "Signup" });
    window.open(route.href, "_blank");
  }

  gotoLogin() {
    const route = this.$router.resolve({ name: "Login" });
    window.open(route.href, "_blank");
  }
  async favedStatus() {
    if (this.$store.getters.user.id) {
      const response = await SalonFavoriteService.getSalon(this.salon_id);
      if (response.data.salon_favorite) {
        this.faved = true;
      } else {
        this.faved = false;
      }
    }
  }

  public async created() {
    this.salon_id = String(this.$route.params.salon_id);
    const response = await SalonService.getSalons({
      salon_id: this.salon_id,
      status: 1,
    });
    if (response.data.salons.length > 0) {
      this.salonExists = true;
      this.salon = response.data.salons[0];
      this.salon_id = this.salon.salon_id;
      this.$store.dispatch("actionSetHeaderUrl", this.salon.image_logo_url);
      this.$store.dispatch("actionSetSalonName", this.salon.salon_name);
      document.title =
        "サービス一覧 | " +
        this.salon.salon_name +
        " | favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
      const descriptonMeta = document.querySelector("meta[name='description']");
      if (descriptonMeta) {
        descriptonMeta.setAttribute(
          "content",
          "サービス一覧 | " +
            this.salon.salon_name +
            " | favsalon（ファブサロン）なら美容室やネイルサロン、リラクサロンなどのサロンメニューに特化したネットサロンを簡単に作ることができます。シークレットメニューで来店者のみに販売するサービスを作って再来率を向上させます！"
        );
      }
      const robotsMeta = document.querySelector("meta[name='robots']");
      if (robotsMeta) {
        robotsMeta.setAttribute("content", "index, follow");
      }
      this.title = document.title;
      const ogpImageMeta = document.querySelector("meta[property='og:image']");
      if (ogpImageMeta) {
        ogpImageMeta.setAttribute("content", this.salon.image_url);
      }
    }

    const responseTickets = await SalonService.getTickets(this.salon_id, {
      page: this.page,
      per_page: this.maxIndex,
    });
    if (responseTickets.data.tickets) {
      this.tickets = responseTickets.data.tickets;
    }
    if (this.tickets.length > 0) {
      this.ticketExists = true;
    }
    this.viewTickets = this.tickets;
    this.total_objects = responseTickets.data.total_objects;
  }

  @Watch("selectedTicketType", { deep: true })
  onSelectedTicketTypeChanged() {
    this.selectTickets();
  }
}
